import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const NewContactForm = forwardRef(({contact, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={{contact: {}, company: {}, location: {}}}
      type="contact"
      entityKey="entities"
      fieldsComponent={Fields}
      onSave={(update) => services.contact.saveContact(update)}
      onSaved={onSaved}
    />
  );
});

export default NewContactForm;
